import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    rows: [
                        {
                            view: 'datatable', // First datatable for withdrawal requests
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'ComissionId',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId',
                                    header: _('Punto de Venta'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre usuario'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserType',
                                    header: _('Tipo de usuario'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Value',
                                    header: _('Valor'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type for this column
                                },
                                {
                                    id: 'DateFrom',
                                    header: _('Fecha Inicio'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateTo',
                                    header: _('Fecha Fin'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Type',
                                    header: _('Pago de comisiones'), // Localized header
                                    width: 150,
                                    options: [
                                        // Options for dropdown
                                        { id: 'S', value: _('Saldo') },
                                        { id: 'F', value: _('Factura') },
                                    ],
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // Localized header
                                    options: [
                                        // Options for dropdown
                                        { id: '', value: _('Ninguno') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'ComissionsType',
                                    header: _('Tipo de comisión'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha Creación'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            editable: true, // Enable editing
                            footer: false, // Disable footer
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA', // Pager ID
                        },
                        {
                            view: 'datatable', // Second datatable for summary
                            id: 'datatable2', // ID for the second datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions for the second datatable
                                {
                                    id: 'DateFrom',
                                    header: _('Fecha Inicio'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateTo',
                                    header: _('Fecha Fin'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Total',
                                    header: _('Total'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for price
                                    exportType: 'number', // Export type for this column
                                },
                            ],
                            footer: true, // Enable footer
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the first datatable
        $$('datatable2').hide(); // Hide the second datatable initially
        var url = devConfig.geturlApi() + 'Financial/GetComissionsPayment'; // API endpoint
        var filter = ''; // Filter string
        this.on(this.app, 'withdrawalReport:filter', (filterData) => {
            // Event listener for filter changes
            if (filterData.Type === 1) {
                // Check filter type
                $$('datatable').hide(); // Hide first datatable
                $$('datatable2').show(); // Show second datatable
                $$('datatable2').adjust(); // Adjust second datatable
                grid = $$('datatable2'); // Update grid reference
            } else {
                $$('datatable').show(); // Show first datatable
                $$('datatable').adjust(); // Adjust first datatable
                $$('datatable2').hide(); // Hide second datatable
            }
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Append dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Append dateTo to query string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Exclude 'Date' key
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Append dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Append dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Append to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Append to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            $$('filterPopup').hide(); // Hide filter popup
            filter = string1; // Update filter string
        });
    }
}

// FILE DOCUMENTED
